import React from "react";
import { useSmoothScrollContext } from "../context/SmoothScrollContext";

const TauxInsertion = () => {
    const { handleLinkClick } = useSmoothScrollContext();
    const programs = [
        {
            title: "Bachelor in International management",
            data: [
                {type: "Contrat à durée déterminée", months3: "60%", months6: "55%", months12: "25%"},
                {type: "Contrat à durée indéterminée", months3: "15%", months6: "43%", months12: "75%"},
                {type: "Total", months3: "75%", months6: "98%", months12: "100%"}
            ]
        },
        {
            title: "MBA in International management",
            data: [
                {type: "Contrat à durée déterminée", months3: "45%", months6: "21%", months12: "5%"},
                {type: "Contrat à durée indéterminée", months3: "40%", months6: "77%", months12: "95%"},
                {type: "Total", months3: "85%", months6: "98%", months12: "100%"}
            ]
        }
    ];

    return (
        <div id="tauxinsertion" className="section-padding">
            <div className="container">
                <div className="text-center">
                    <div className="mini-title">Taux d'insertion</div>
                    <div className="column-title tw-leading-tight">
                        <span className="shape-bg">Taux d'insertion</span> professionnelle à l'issue des formations
                        Vatel en management hôtelier
                    </div>
                </div>
                <div className="px-2 sm:px-6 lg:px-8">
                    <div className="grid grid-cols-1 lg:grid-cols-2 tw-gap-8">
                        {programs.map((program, index) => (
                            <div key={index} className="mt-8">
                                <div className="sm:flex sm:items-center">
                                    <div className="sm:flex-auto">
                                        <h1 className="font-semibold text-gray-900 text-xl sm:text-2xl">{program.title}</h1>
                                    </div>
                                </div>
                                <div className="mt-8 tw-overflow-x-auto">
                                    <div className="tw-inline-block tw-min-w-full tw-align-middle rounded-lg overflow-hidden">
                                        <table className="tw-min-w-full tw-divide-y tw-divide-gray-300">
                                            <thead>
                                            <tr>
                                                <th scope="col" className="tw-bg-gray-50 tw-p3 pl-2 sm:pl-4 tw-p-2 text-left text-sm font-semibold text-gray-900">
                                                    Qualification
                                                </th>
                                                <th scope="col" className="tw-bg-gray-50 px-2 sm:px-3 tw-p3 text-left text-sm font-semibold text-gray-900">
                                                    +3 mois
                                                </th>
                                                <th scope="col" className="tw-bg-gray-50 px-2 sm:px-3 tw-p3 text-left text-sm font-semibold text-gray-900">
                                                    +6 mois
                                                </th>
                                                <th scope="col" className="tw-bg-gray-50 px-2 sm:px-3 tw-p3 text-left text-sm font-semibold text-gray-900">
                                                    +12 mois
                                                </th>
                                            </tr>
                                            </thead>
                                            <tbody className="tw-divide-y tw-divide-gray-200 tw-bg-white">
                                            {program.data.map((row, rowIndex) => (
                                                <tr
                                                    key={rowIndex}
                                                    className={row.type === "Total" ? "tw-bg-teal-500" : ""}
                                                >
                                                    <td className="tw-whitespace-normal sm:tw-whitespace-nowrap tw-p-2 text-sm font-medium text-gray-900">
                                                            <span className={row.type === "Total" ? "text-white" : ""}>
                                                                {row.type}
                                                            </span>
                                                    </td>
                                                    <td className="tw-whitespace-nowrap px-2 sm:px-3 py-2 sm:py-4 text-sm">
                                                            <span className={row.type === "Total" ? "text-white font-bold" : "text-gray-500 font-bold"}>
                                                                {row.months3}
                                                            </span>
                                                    </td>
                                                    <td className="tw-whitespace-nowrap px-2 sm:px-3 py-2 sm:py-4 text-sm">
                                                            <span className={row.type === "Total" ? "text-white font-bold" : "text-gray-500 font-bold"}>
                                                                {row.months6}
                                                            </span>
                                                    </td>
                                                    <td className="tw-whitespace-nowrap px-2 sm:px-3 py-2 sm:py-4 text-sm">
                                                            <span className={row.type === "Total" ? "text-white font-bold" : "text-gray-500 font-bold"}>
                                                                {row.months12}
                                                            </span>
                                                    </td>
                                                </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="pt-8 text-center">
                        <a
                            id="btn-brochure-taux"
                            href="#brochure"
                            onClick={(e) => handleLinkClick(e, 'brochure')}
                            className="btn btn-primary w-full lg:w-auto inline-block text-center"
                        >
                            Demandez votre brochure
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TauxInsertion;